{
  "version": 1,
  "asset_id": "dca5b585-ecb7-498a-9b31-be4450779e34",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/dca5b585-ecb7-498a-9b31-be4450779e34/hiatal-type-3-sleeve-en-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/dca5b585-ecb7-498a-9b31-be4450779e34/hiatal-type-3-sleeve-en-800.webp",
  "original_filename": "hiatal-type-3-sleeve-en-800.webp",
  "size": 60280,
  "content_type": "image/webp",
  "created_at": "2026-09-26T23:10:58Z"
}
